import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { X } from 'lucide-react';
import apiClient from '../utils/api';
import './TrialBanner.css';

function TrialBanner() {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [subscriptionStatus, setSubscriptionStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const [dismissed, setDismissed] = useState(false);
  const isGerman = i18n.language === 'de';

  useEffect(() => {
    loadSubscriptionStatus();
    // Check if banner was dismissed in this session
    const wasDismissed = sessionStorage.getItem('trialBannerDismissed');
    if (wasDismissed) {
      setDismissed(true);
    }
  }, []);

  const loadSubscriptionStatus = async () => {
    try {
      const status = await apiClient.getSubscriptionStatus();
      setSubscriptionStatus(status);
    } catch (error) {
      console.error('Error loading subscription status:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleDismiss = () => {
    setDismissed(true);
    sessionStorage.setItem('trialBannerDismissed', 'true');
  };

  if (loading || !subscriptionStatus || dismissed) {
    return null;
  }

  // Don't show banner if already subscribed
  if (subscriptionStatus.is_subscribed) {
    return null;
  }

  // Show trial banner
  if (subscriptionStatus.is_trial) {
    const trialEnd = new Date(subscriptionStatus.trial_end_date);
    const now = new Date();
    const daysLeft = Math.ceil((trialEnd - now) / (1000 * 60 * 60 * 24));

    return (
      <div className="trial-banner">
        <div className="trial-banner-content">
          <div className="trial-icon">⏳</div>
          <div className="trial-text">
            <strong>{isGerman ? 'Kostenlose Testphase:' : 'Free trial:'}</strong> {t('trialBanner.message', { days: daysLeft })}
          </div>
          <button onClick={() => navigate('/pricing')} className="btn-upgrade-trial">
            {t('trialBanner.upgrade')}
          </button>
          <button 
            onClick={handleDismiss} 
            className="btn-dismiss-banner"
            data-testid="dismiss-trial-banner"
          >
            <X size={18} />
          </button>
        </div>
      </div>
    );
  }

  // Trial expired - show upgrade banner (also dismissible)
  return (
    <div className="trial-banner expired">
      <div className="trial-banner-content">
        <div className="trial-icon">⚠️</div>
        <div className="trial-text">
          <strong>{t('trialBanner.messageExpired')}</strong>
        </div>
        <button onClick={() => navigate('/pricing')} className="btn-upgrade-expired">
          {t('trialBanner.upgrade')}
        </button>
        <button 
          onClick={handleDismiss} 
          className="btn-dismiss-banner"
          data-testid="dismiss-expired-banner"
        >
          <X size={18} />
        </button>
      </div>
    </div>
  );
}

export default TrialBanner;
